import { Button, Loading, Table, type TableConfig, Title } from 'src/components';
import { Grid } from '@material-ui/core';
import { getCourseStatusChip } from 'src/helpers';
import { history, type RootState } from 'src/store';
import { useEffect, useState } from 'react';
import CertificateDialog from './CertificateDialog';
import CourseDrawerForm from './CourseDrawerForm';
import useStyles from './Courses-styles';

import { useDispatch, useSelector } from 'react-redux';
import { userTypes } from 'src/helpers/constants';
import courseActions from 'src/store/Courses/actions';

function getColumns(userType: string): TableConfig[] {
	switch (userType) {
		case userTypes.USER:
			return [
				{
					key: 'name',
					label: 'Nombre',
					render: (value: any, row: any) => value,
				},
				{
					align: 'center',
					key: 'passed',
					label: 'Estatus',
					render: (value: any, row: any) => getCourseStatusChip(row),
				},
				{
					align: 'center',
					key: 'qualification',
					label: 'Calificación',
					render: (value: any, row: any) => (parseFloat(value) > 0 ? value : ''),
				},
				{
					align: 'center',
					key: 'attempt',
					label: 'Intento',
					render: (value: any, row: any) => `${value}/${row.maxAttempts}`,
				},
			];

		default:
			return [
				{
					key: 'name',
					label: 'Nombre',
					render: (value: any, row: any) => value,
				},
			];
	}
}

function Courses() {
	const classes = useStyles();
	// NOTE: Ver todas las notas de ./src/modules/private/Admin.tsx
	const dispatch = useDispatch();
	const getCourses = (page: number, pageSize: number) => dispatch(courseActions.getAll(page, pageSize));
	const getCoursesByUser = (userId: string) => dispatch(courseActions.getByUser(userId));
	const getCoursesByInstitution = (institutionId: number) =>
		dispatch(courseActions.getByInstitution(institutionId));
	const { courses, institutionCourses, isLoading, metadata, page, pageSize } = useSelector(
		(state: RootState) => state.courses,
	);
	const { id: userId, institutionId, type: userType } = useSelector((state: RootState) => state.auth.data);
	const [drawer, setDrawer] = useState({ courseId: 0, open: false });
	const [certificate, setCertificate] = useState({ course: {}, open: false });

	useEffect(() => {
		switch (userType) {
			case userTypes.USER:
				getCoursesByUser(userId);
				break;

			case userTypes.INSTITUTION:
				getCoursesByInstitution(institutionId);
				break;

			default:
				getCourses(1, pageSize);
				break;
		}
	}, [userType]);

	function handlePagination(event: any, newPage: number) {
		getCourses(newPage, pageSize);
	}

	const actions =
		userType === userTypes.USER
			? [
				{
					disabled: (row: any) => row.attempt === 0,
					label: 'Revisión',
					onClick: (row: any) => {
						history.push(`/app/courses/exam/review/${row.id}/${userId}`);
					},
				},
				{
					disabled: (row: any) => !row.passed,
					label: 'Ver certificado',
					onClick: (row: any) => {
						setCertificate({ course: row, open: true });
					},
				},
				{
					label: 'Ver',
					onClick: (row: any) => {
						history.push(`/app/courses/${row.id}`);
					},
				},
			]
			: [
				{
					label: 'Detalle',
					onClick: (row: any) => {
						history.push(`/app/courses/edit/${row.id}`);
					},
				},
			];

	return (
		<Grid container>
			<CertificateDialog
				course={certificate.course}
				handleOpen={() => {
					setCertificate({ course: {}, open: false });
				}}
				open={certificate.open}
			/>

			<CourseDrawerForm
				courseId={drawer.courseId}
				from={'list'}
				onClose={() => {
					setDrawer({ courseId: 0, open: false });
				}}
				open={drawer.open}
			/>

			<Grid item xs={6}>
				<Title breadcrumbs={[{ label: 'Cursos' }]} title={'Cursos'} />
			</Grid>

			<Grid className={classes.buttonContainer} item xs={6}>
				{userType === userTypes.ADMIN && (
					<Button
						actionType={'add'}
						hideLabelOnMobile
						onClick={() => {
							setDrawer({ courseId: 0, open: true });
						}}
					>
						Crear
					</Button>
				)}
			</Grid>

			<Loading isLoading={isLoading}>
				<Table
					actions={actions}
					columns={getColumns(userType)}
					data={courses}
					handlePagination={handlePagination}
					metadata={metadata}
					page={page}
				/>
			</Loading>
		</Grid>
	);
}

export default Courses;
